import AxiosService from './AxiosService'

class SyslogConfigRestService {
  static getConfig(): Promise<any> {
    return AxiosService.get('/settings/syslogconfigs')
  }

  static createConfig(syslogconfig: any): Promise<any> {
    return AxiosService.post('/settings/syslogconfigs', syslogconfig)
  }

  static updateConfig(syslogconfig: any): Promise<any> {
    return AxiosService.put(`/settings/syslogconfigs/${syslogconfig.id}`, syslogconfig)
  }

  static deleteConfig(id: number): Promise<any> {
    return AxiosService.delete(`/settings/syslogconfigs/${id}`)
  }
}

export default SyslogConfigRestService
